import Vue from 'vue';
import axios from 'axios';

const api = axios.create({
    baseURL: 'https://tracyapi.fvgservices.be/',
});


// api.defaults.headers.common['Authorization'] = 'Token' + localStorage.getItem('authToken');
api.defaults.headers.common.Authorization = 'Bearer ' + localStorage.getItem(`${process.env.VUE_APP_NAME}_bearerToken`);

Vue.prototype.$api = api;
